import { Item } from "../../models/item";

export const SET_CONFIGURATION = "SET_CONFIGURATION";
export const CONFIGURATION_LOADED = "CONFIGURATION_LOADED";

export const ADD_ITEM = "ADD_ITEM";
export const REMOVE_ITEM = "REMOVE_ITEM";
export const SET_SELECTED_MENU = "SET_SELECTED_MENU";
export const SET_MENU_ITEMS = "SET_MENU_ITEMS";
export const SET_ITEM_STATES = "SET_ITEM_STATES";
export const PREVIEW_ITEM = "PREVIEW_ITEM";
export const CLEAR_PREVIEW_ITEM = "CLEAR_PREVIEW_ITEM";
export const SET_PREVIEW_ITEM = "SET_PREVIEW_ITEM";
export const SET_MENU_STRUCTURE = "SET_MENU_STRUCTURE";
export const SET_SUMMARY_ITEMS = "SET_SUMMARY_ITEMS";
export const SET_IMAGE_URL = "SET_IMAGE_URL";

export type AddItemAction = {
    item: Item;
    requiredItems?: Item[];
    removedItems?: Item[];
};
